// removed by extract-text-webpack-plugin
module.exports = {"batch-cancel-modal":"BulkActionConfirm__batch-cancel-modal___SW5N6"};